import { ConfigurationResponse } from "redux/services/config";

export const logDebugData = (data: ConfigurationResponse) => {
  const floor_id = data.location.floor;

  const floorObj = Object.entries(data.floors).find(
    ([key]) => key === String(floor_id),
  );
  const floor = floorObj ? floorObj[1].floor : null;

  const debugData = {
    id: data.screen_id,
    project: data.project,
    name: data.components.top_bar.lang?.["en-GB"].heading,
    description: data.components.top_bar.lang?.["en-GB"].subheading,
    location: {
      latitude: data.location.latitude,
      longitude: data.location.longitude,
      heading: data.location.bearing,
      floor_id,
      floor,
    },
    center: {
      latitude: data.components.map_primary.center[0],
      longitude: data.components.map_primary.center[1],
      heading: data.components.map_primary.bearing,
      floor_id,
      floor,
    },
    marker: {
      latitude: data.components.map_primary.you_marker.latitude,
      longitude: data.components.map_primary.you_marker.longitude,
      heading: data.components.map_primary.you_marker.bearing,
      floor_id,
      floor,
    },
    links: {
      self: window.location.href,
      ...data.links,
    },
  };

  console.log(debugData);
};
